/*	Copyright (c) 1996 - 2026 NoWatt Ltd				*/
/*	  All Rights Reserved  											*/

import React from 'react';

const Products = () => (
  <div id="tf-works">
    <div className="container">
      <div className="section-title text-center center">
        <h2><strong>Our products</strong></h2>
        <div className="line"><hr /></div>
        <div className="clearfix" />
        <p className="intro"><em>
          Smart appliances, connected via the internet, can now be monitored 24/7.
          Real-time IoT performance data can reduce repair costs, minimise downtime and keep equipment
          operating at peak performance, but it needs to be actionable. This is what we do.
        </em></p>
      </div>
      <div className="space" />
      <div className="row">
        <div className="col-sm-6 col-md-3 col-lg-3 software"><div className="portfolio-item"><div className="hover-bg">
          <a href="mm"><div className="hover-text"><h4>Predictive Maintenance</h4><div className="clearfix" /><i className="fa fa-plus" /></div>
            <img className="img-fluid" src="img/portfolio/ipad.png" alt="..." />
          </a>
        </div></div></div>
        <div className="col-sm-6 col-md-3 col-lg-3 analysis"><div className="portfolio-item"><div className="hover-bg">
          <a href="analysis"><div className="hover-text"><h4>Data Analysis</h4><small>AI</small><div className="clearfix" /><i className="fa fa-plus" /></div>
            <img className="img-fluid" src="img/portfolio/analysis.png" alt="..." />
          </a>
        </div></div></div>
        <div className="col-sm-6 col-md-3 col-lg-3 hardware"><div className="portfolio-item"><div className="hover-bg">
          <a href="inside"><div className="hover-text"><h4>Built-In</h4><div className="clearfix" /><i className="fa fa-plus" /></div>
            <img className="img-fluid" src="img/portfolio/fosters.png" alt="..." />
          </a>
        </div></div></div>
        <div className="col-sm-6 col-sm-6 col-md-3 col-lg-3 hardware"><div className="portfolio-item"><div className="hover-bg">
          <a href="smp"><div className="hover-text"><h4>Smart Monitoring</h4><small>PLUS+</small><div className="clearfix" /><i className="fa fa-plus" /></div>
            <img className="img-fluid" src="img/portfolio/collector.png" alt="..." />
          </a>
        </div></div></div>
      </div>
    </div>
  </div>
);

export default Products;
